import React, { useState } from "react";
import { Form, Button, DatePicker, Input } from "antd";
import { ReactSVG } from "react-svg";
import moment from "moment";

const codeTips = "Should be 8 numbers";
const MaintenanceForm = ({
	handleSubmitForm,
	form,
	handleCancel,
	maintenanceId,
}) => {
	const [code, setCode] = useState({});

	const onFinish = (values) => {
		const newValues = values;
		newValues.periodFrom = values.periodFrom
			? moment(values.periodFrom).format("DD/MM/YYYY HH:mm")
			: null;
		newValues.periodTo = values.periodTo
			? moment(values.periodTo).format("DD/MM/YYYY HH:mm")
			: null;
		handleSubmitForm(newValues);
	};

	function validateCode(value) {
		if (value === "") {
			return {
				validateStatus: "error",
				errorMsg: "Required",
			};
		}
		if (!value || (value.length === 8 && /^[0-9]+$/.test(value))) {
			return {
				validateStatus: "success",
				errorMsg: null,
			};
		}

		return {
			validateStatus: "error",
			errorMsg: "Should be 8 numbers",
		};
	}

	const onCodeChange = (event) => {
		const { value } = event.target;
		setCode({ ...validateCode(value), value });
	};

	return (
		<div className="maintenance-form-container">
			<Form form={form} onFinish={onFinish} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item
						label="Code"
						name="code"
						rules={[{ required: true, message: "Required" }]}
						validateStatus={code.validateStatus}
						help={code.errorMsg || codeTips}
					>
						<Input placeholder="Code" onChange={onCodeChange} />
					</Form.Item>
					<Form.Item
						label="Period From"
						name="periodFrom"
						rules={[{ required: true, message: "Required" }]}
					>
						<DatePicker
							format="DD/MM/YYYY HH:mm"
							showTime
							style={{ width: "100%" }}
						/>
					</Form.Item>
					<Form.Item
						label="Period To"
						name="periodTo"
						rules={[{ required: true, message: "Required" }]}
					>
						<DatePicker
							format="DD/MM/YYYY HH:mm"
							showTime
							style={{ width: "100%" }}
						/>
					</Form.Item>
				</div>
				<div className="form-actions">
					<Button type="link" onClick={handleCancel}>
						{" "}
						Cancel{" "}
					</Button>
					<Button type="primary" htmlType="submit" className="btn-primary">
						{maintenanceId ? "Update" : "Create"}
						<ReactSVG src="/icons/check-button.svg" />
					</Button>
				</div>
			</Form>
		</div>
	);
};

export default MaintenanceForm;
